<div class="flex flex-wrap flex-row">
  <div class="flex flex-col w-full mb-3">
    <h1>Coverage Adjustment</h1>
    <div class="mt-2 mb-6">
      <lib-button [cssType]="'btn-link'" [text]="backToText()" [icon]="'circleleft'" [buttonType]="'button'"
      (click)="goBack()"></lib-button>
    </div>
  </div>
  <mat-horizontal-stepper #stepper class="wizard-stepper" [linear]="true" [selectedIndex]="selectedIndex()">
    <mat-step [stepControl]="step1Form" label="Quote">
      <lib-coverage-adjustment-step1 [form]="step1Form"
        [displayGenerateQuote]="displayAdminButtons || displayWholesalerButtons"
      class="step"></lib-coverage-adjustment-step1>
    </mat-step>
    <mat-step label="Price">
      <lib-coverage-adjustment-step2 [form]="step2Form" class="step"
      [disableReQuote]="!displayAdminButtons && !displayWholesalerButtons"></lib-coverage-adjustment-step2>
    </mat-step>
  </mat-horizontal-stepper>
</div>
<div class="justify-center flex">
  <div class="flex flex-col gap-3">
    @if (stepper != null ? stepper?.selected === stepper?.steps?.last : false) {
      @if (data.mode !== 'view' && data?.policyChangeStatus !== 'Requested' && displayAdminButtons || displayWholesalerButtons) {
        <lib-button
          [cssType]="'btn-primary'" [text]="'Submit Request'" [icon]="'rightarrow'" [size]="'large'" (click)="submitRequest()">
        </lib-button>
      }
      @if (data?.policyChangeStatus === 'Requested' && displayAdminButtons) {
        <div class="flex items-center gap-3">
          <lib-button [cssType]="'btn-primary'" [text]="'Issue Endorsement'" [size]="'large'"
          (click)="issuePolicyChange()"></lib-button>
          <lib-button [cssType]="'btn-secondary'" [text]="'Decline'" [size]="'large'" (click)="decline()"></lib-button>
        </div>
      }
    } @else {
      <lib-button [cssType]="'btn-primary'" [text]="'Proceed to Price'" [size]="'large'" [icon]="'rightarrow'"
      (click)="proceed(stepper.selectedIndex + 1, { save: true })"></lib-button>
    }
    @if (displayAdminButtons || displayWholesalerButtons) {
      <lib-button [cssType]="'btn-link'"
        class="justify-center flex primary" [text]="'Save and Return to Policy'" [size]="'large'" (click)="saveAndClose()">
      </lib-button>
    }
  </div>
</div>